import React from "react";
import { useAuth } from "../context/AuthContext";
import BreederStats from "./BreederStats";
import RestaurantStats from "./RestaurantStats";

const Stats = () => {
  const { isBreeder, isRestaurant } = useAuth();

  if (isBreeder) {
    return <BreederStats />;
  }

  if (isRestaurant) {
    return <RestaurantStats />;
  }

  return (
    <div className="container main-content">
      <div className="alert alert-error">
        Vous devez être connecté pour voir cette page.
      </div>
    </div>
  );
};

export default Stats;

